import { render } from "./like.vue?vue&type=template&id=48c8ac96"
const script = {}
script.render = render

export default script